<template>
<v-card flat >
  <v-window v-model='screen' >
    <v-window-item touchless >
      <v-list dense>
        <v-subheader >
          <v-btn @click='load' small icon >
            <v-icon small >replay</v-icon>
          </v-btn>
          {{ $t('list.title') }}
          <v-spacer></v-spacer>
          <v-btn @click='screen=screens.NEW' icon small><v-icon>add</v-icon></v-btn>
          <v-btn @click='showSearch=!showSearch' icon small><v-icon>search</v-icon></v-btn>
          <v-btn @click='load' icon small><v-icon>replay</v-icon></v-btn>
        </v-subheader>
        <v-text-field v-if='showSearch'
          solo
          v-model='searchText'
          label='search'
          class='mx-2'
          prepend-icon="search"
          clearable >
        </v-text-field>
        <v-progress-linear indeterminate height="3" v-if='getRequest.loading' ></v-progress-linear>
        <v-list-tile
          v-for='therapist in filteredTherapists'
          :key='therapist.id'
          @click="selected(therapist)" >
          <v-list-tile-content >
              <v-list-tile-title>
                {{ therapist.title }}
                {{ therapist.initials }}
                {{ therapist.first_name }}
                {{ therapist.last_name }}
              </v-list-tile-title>
              <v-list-tile-sub-title >
                {{ therapist.reference_number}}
              </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-btn @click='screen=screens.NEW' flat small>
        <v-icon>add</v-icon>
        {{ $t('buttons.add') }}</v-btn>
    </v-window-item>

    <!-- add a referrer -->
    <v-window-item >
      <v-card flat>
        <v-card-text>
          <server-errors :request='saveRequest'>
          </server-errors>
          <object-form
            v-model='newReferrer'
            ref='createForm'
            :fields="referrerFields"
            :field-configs='fieldConfigs'
            :errors='serverErrors' >
            <v-select
              slot='title'
              :items="titles"
              v-model='newReferrer.title'
              label="Title" >
            </v-select>
          </object-form >
        </v-card-text>
        <v-card-actions>
          <v-spacer>
          </v-spacer>
          <v-btn flat small
            href='http://isystems.hpcsa.co.za/iregister/' target="_blank" >
            <v-icon small class='pr-2' >search</v-icon> {{ $t('buttons.searchhpcsa') }} <v-icon class='pl-2' small>open_in_new</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-actions v-if='$refs.createForm' >
          <v-btn @click='screen=0' flat >{{ $t('buttons.back') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            @click='save'
            :disabled="!$refs.createForm.valid"
            color='primary'
            :loading='saveRequest.loading' >{{ $t('buttons.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-window-item>

    <!-- referrer added -->
    <v-window-item >
      <v-card flat>
        <v-card-title class='subheading'>
          {{ $t('cards.success.title') }}
        </v-card-title>
        <v-card-text class='text-xs-center' >
          <v-icon color='success' large >check_circle</v-icon>
          <blockquote class='blockquote' >
            {{ $t('cards.success.message') }}: <br/>
            {{newReferrer.first_name}} {{newReferrer.last_name}}
          </blockquote>
          <v-btn @click='screen=screens.NEW' flat >
            {{ $t('buttons.addanother') }}</v-btn>
          <v-btn
            @click="selected(newReferrer)" color='primary' >
            {{ $t('buttons.select') }} {{ newReferrer.first_name }}
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click='screen=screens.LIST' >
            <v-icon >chevron_left</v-icon>
            {{ $t('buttons.backtostart') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-window-item>
  </v-window>
</v-card>
</template>

<script>
import ObjectForm from '@/components/medicalaid/ObjectForm'
import ServerErrors from '@/components/ServerErrors'
import { TITLES } from '@/store/constants'
export default {
  name: 'ReferralPicker',
  components: { ObjectForm, ServerErrors },
  props: {
    touch: { type: Number, default: 2 },
    closeOnSelect: { type: Boolean, default: true }
  },
  data () {
    return {
      screen: 0,
      showSearch: false,
      searchText: '',
      titles: TITLES,
      serverErrors: {},
      newReferrer: {
        'created_by': '',
        'title': '',
        'first_name': '',
        'last_name': '',
        'reference_number': ''
      },
      screens: {
        LIST: 0,
        NEW: 1,
        SUCCESS: 2
      },
      referrerFields: [
        'title',
        'first_name',
        'last_name',
        'reference_number'
      ],
      fieldConfigs: {
        'first_name': {
          rules: [v => !!v || 'first name is required']
        },
        'last_name': {
          rules: [v => !!v || 'last name is required']
        },
        'reference_number': {
          hint: 'e.g.: BK 1234567, MP 1234567, DT 1234567, PT 1234567 etc.',
          persistentHint: true
        }
      },
      getReq: 'get-therapist-list',
      saveReq: 'save-therapist-list'
    }
  },
  computed: {
    getRequest () {
      return this.$store.getters.getRequestById(this.getReq, true)
    },
    saveRequest () {
      return this.$store.getters.getRequestById(this.saveReq, true)
    },
    saveRequestStatus () {
      return this.saveRequest.status
    },
    therapists () {
      return this.getObjectPath(this.getRequest, 'result.data.results', [])
    },
    filteredTherapists () {
      if (!this.therapists) { return [] }
      if (this.searchText && this.searchText.length > 1) {
        return this.therapists.filter((item) => {
          let index = `${item.title} ${item.first_name} ${item.last_name} ${item.reference_number}`.toLowerCase()
          return (index.indexOf(this.searchText) !== -1)
        })
      }
      return this.therapists
    }
  },
  watch: {
    saveRequestStatus () {
      if (this.saveRequestStatus === 201) {
        this.newReferrer = this.saveRequest.result.data
        this.screen = this.screens.SUCCESS
      }
    },
    touch () {
      this.reset()
      this.load()
    }
  },
  methods: {
    reset () {
      this.screen = this.screens.LIST
    },
    load () {
      this.$medicalaidguru
        .resource('therapist')
        .id(this.getReq)
        .list()
    },
    save () {
      this.newReferrer.created_by = this.me.id
      this.$medicalaidguru
        .resource('therapist')
        .id(this.saveReq)
        .create(this.newReferrer)
    },
    selected (therapist) {
      this.reset()
      this.$emit('selected', therapist)
      if (this.closeOnSelect === true) {
        this.$emit('close')
      }
    }
  },
  i18n: {
    messages: {
      en: {
        list: {
          title: 'Referrers'
        },
        buttons: {
          add: 'Add a new referrer',
          addanother: 'Add another',
          select: 'Select',
          back: 'Back',
          save: 'Save',
          searchhpcsa: 'Search HPCSA registry',
          backtostart: 'Back to search'
        },
        cards: {
          success: {
            title: 'New referrer created',
            message: 'Successfully created referrer'
          }
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ReferralPicker.vue?2bec0162